module.exports = __webpack_public_path__ + "img/arrow-down-circle-outline.56265bf8.svg";